import React from "react";
import ReactApexChart from 'react-apexcharts'

const DashboardCounts = (props) =>
{
    const pass = props.moduleResults.filter(x => x.Decision === "Pass")
    const fail = props.moduleResults.filter(x => x.Decision === "Fail")

    const date_difference = props.semesterProgress.length > 0 ? props.semesterProgress[0].date_difference : 0
    const todays_diff = props.semesterProgress.length > 0 ? props.semesterProgress[0].todays_diff : 0
    let semesterProg;
    if (props.semesterProgress.length > 0)
    {
        semesterProg = (todays_diff / date_difference) * 100
    } else
    {
        semesterProg = 100
    }

    const [state, setState] = React.useState({
        series: [props.registredModules.length, pass.length, fail.length, props.registredModules.length > 0 ?
            props.registredModules.filter(x => x.SemesterCode === props.currentsemester).length
            : 0],
        options: {
            chart: {
                width: 380,
                type: 'donut',
            },
            labels: ['Registered Modules', 'Passed Modules', 'Failed Modules', 'Currently Taking'], // Add your labels here
            dataLabels: {
                enabled: false
            },
            responsive: [{
                breakpoint: 480,
                options: {
                    chart: {
                        width: 200
                    },
                    legend: {
                        show: false
                    }
                }
            }],
            legend: {
                position: 'right',
                offsetY: 0,
                height: 230,
            }
        },
    });

    return (
        <div className="col-md-6 d-flex">
            <div className="card flex-fill">
                <div className="card-header d-flex align-items-center justify-content-between">
                    <h4 className="card-title">Student Progress</h4>
                </div>
                <div className="card-body">
                    <div className="attendance-chart">
                        {/*<p className="mb-3"><i className="ti ti-calendar-heart text-primary me-2"></i>No of total working days <span className="fw-medium text-dark"> 28 Days</span></p>*/}
                        <div className="border rounded p-3">
                            <div className="row">
                                <div className="col text-center border-end">
                                    <p className="mb-1">Registered Modules</p>
                                    <h5>{props.registredModules.length}</h5>
                                </div>
                                <div className="col text-center border-end">
                                    <p className="mb-1">Passed Modules</p>
                                    <h5>{pass.length}</h5>
                                </div>
                                <div className="col text-center">
                                    <p className="mb-1">Failed Modules</p>
                                    <h5>{fail.length}</h5>
                                </div>
                                <div className="col text-center">
                                    <p className="mb-1">Currently Taking</p>
                                    <h5>
                                        {
                                            props.registredModules.length > 0 ?
                                                props.registredModules.filter(x => x.SemesterCode === props.currentsemester).length
                                                : 0
                                        }
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div className="text-center">

                            <div className="chart-wrap">
                                <div id="chart">
                                    <ReactApexChart options={state.options} series={state.series} type="donut" width={380} />
                                </div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    )
}

export default DashboardCounts;